import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { Task } from '@app/models/tasks/task.model';

@Component({
    selector: 'app-deprecated-task-details',
    templateUrl: './deprecated-task-details.template.html',
    styleUrls: ['./deprecated-task-details.style.scss'],
})
export class DeprecatedTaskDetailsComponent {
    @Output() done: EventEmitter<void> = new EventEmitter<void>();

    @Input() task: Task;

    constructor(protected element: ElementRef) {}

    onDone(): void {
        this.done.emit();
    }
}
